import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRetweet } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { isRepostablePost } from '@components/Feed/Post/ActionButtons';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import {
  type FragmentType,
  getFragment,
  PostGroupItemFragmentDoc,
  type UserActivityDetailFragmentDoc,
} from '@graphql/reactQuery';
import { webappUriPath } from '@utils/url';
import { PostItem } from '../Post/PostItem';

export const Repost = ({
  originalPost,
  originalCreator,
  originalPostId,
  originalWebappUri,
  originalTimeStamp,
  creatorWebappUri,
  creatorUsername,
}: {
  originalPost: FragmentType<PostGroupItemFragmentDoc>;
  originalTimeStamp: number;
  originalWebappUri: string;
  originalPostId: string;
  originalCreator: FragmentType<UserActivityDetailFragmentDoc> & { id: string };
  creatorWebappUri: string;
  creatorUsername: string;
}) => {
  if (!isRepostablePost(getFragment(PostGroupItemFragmentDoc, originalPost))) return null;

  return (
    <div className="mt-[-15px] flex flex-col gap-2 ">
      <div className="flex flex-row gap-2 pb-2 pl-4 align-middle text-base-m text-base500 md:pl-8">
        <FontAwesomeIcon icon={faArrowsRetweet} className="text-base500" fontSize={20} />
        <span className="font-medium">
          <AccessibleLink pathnameUri={webappUriPath(creatorWebappUri)} className="font-semibold">
            {creatorUsername}
          </AccessibleLink>{' '}
          reposted
        </span>
      </div>
      <PostItem
        creator={originalCreator}
        post={originalPost}
        postId={originalPostId}
        timeStamp={originalTimeStamp}
        webappUri={originalWebappUri}
      />
    </div>
  );
};
